"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPartnerId = addPartnerId;
exports.default = void 0;
exports.onPhoneNumberValidation = onPhoneNumberValidation;
exports.removeAPiError = removeAPiError;
exports.resetSteps = resetSteps;
exports.saveRegistration = saveRegistration;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _accountDataApi = require("../../../api-factory/accountDataApi");
var _CacheHandler = _interopRequireDefault(require("../../../utils/CacheHandler"));
var _myDataApi = require("../../../api-factory/myDataApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var stages = {
  SecondRegistrationFirstStep: 'SecondRegistrationFirstStep',
  DelimitedStep: 'DelimitedStep',
  SuccessStep: 'SuccessStep'
};
// Actions
var SAVE_NEW_ACCOUNT = 'api/reducer/account/SAVE_NEW_ACCOUNT';
var ADD_NEW_PARTNER = 'api/reducer/account/ADD_NEW_PARTNER';
var RESET_TO_FIRST_STEP = 'api/reducer/account/RESET_TO_FIRST_STEP';
var SHOW_LOADER = 'api/reducer/account/SHOW_LOADER';
var API_ERROR = 'api/reducer/account/API_ERROR';
var REMOVE_API_ERROR = 'api/reducer/account/REMOVE_API_ERROR';
var SEC_DELIMITED = 'api/reducer/account/SEC_DELIMITED';
var HIDE_LOADER = 'api/reducer/account/HIDE_LOADER';
var VALIDATE_PHONENUMBER = 'api/reducer/account/CHECK_PHONENUMBER';
var VALIDATE_PHONENUMBER_PENDING = 'api/reducer/account/CHECK_PHONENUMBER_PENDING';
var VALIDATE_PHONENUMBER_RESET = 'api/reducer/account/CHECK_PHONENUMBER_RESET';
// Reducer
function isPhoneNumberValid(data) {
  var _data$result, _data$result$data, _data$result$data$dat, _data$result$data$dat2;
  return !!(data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : (_data$result$data = _data$result.data) === null || _data$result$data === void 0 ? void 0 : (_data$result$data$dat = _data$result$data.data) === null || _data$result$data$dat === void 0 ? void 0 : (_data$result$data$dat2 = _data$result$data$dat.attributes) === null || _data$result$data$dat2 === void 0 ? void 0 : _data$result$data$dat2.formattedResult);
}
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
var registrationReducer = function registrationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SAVE_NEW_ACCOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        success: true
      });
    case ADD_NEW_PARTNER:
      return _objectSpread(_objectSpread({}, state), {}, {
        step: action.step,
        loading: false
      });
    case RESET_TO_FIRST_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        step: action.step,
        loading: false
      });
    case SHOW_LOADER:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case HIDE_LOADER:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    case API_ERROR:
      {
        var _action$data$innerDat;
        var errorBundler = {};
        var errors = ((_action$data$innerDat = action.data.innerData.response.data) === null || _action$data$innerDat === void 0 ? void 0 : _action$data$innerDat.errors) || [];
        if (errors.length > 0) {
          errors.forEach(function (error) {
            var code = error.code;
            errorBundler[code] = true;
            if (code === 'FIELD_CONTENT') {
              if (error.source.parameter.includes('captcha')) {
                errorBundler["".concat(code, "_captcha")] = true;
              }
            }
            if (code === 'BUSSINESSPARTNER_NUMBER_INVALID') {
              errorBundler.FIELD_CONTENT_businessNumber = true;
              errorBundler.FIELD_CONTENT_contractNumber = true;
            }
          });
        } else {
          errorBundler.FIELD_CONTENT = true;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          errorBundler: errorBundler
        });
      }
    case SEC_DELIMITED:
      {
        var _errorBundler = {};
        _errorBundler[action.data.error] = true;
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          step: stages.DelimitedStep,
          isCompany: action.data.isCompany,
          errorBundler: _errorBundler
        });
      }
    case REMOVE_API_ERROR:
      {
        if (!state.errorBundler || !state.errorBundler[action.errorName]) {
          return state;
        }
        var newErrBundler = _objectSpread({}, state.errorBundler);
        delete newErrBundler[action.errorName];
        return _objectSpread(_objectSpread({}, state), {}, {
          errorBundler: newErrBundler
        });
      }
    case VALIDATE_PHONENUMBER_PENDING:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          phoneNumberValidation: {
            isRequestPending: true,
            isValid: false
          }
        }));
      }
    case VALIDATE_PHONENUMBER:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {
          phoneNumberValidation: {
            isRequestPending: false,
            isValid: isPhoneNumberValid(action.data),
            apiError: action.data.error ? deepClone(action.data.error) : false,
            result: deepClone(action.data)
          }
        }));
      }
    case VALIDATE_PHONENUMBER_RESET:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.data.formName, {}));
      }
    default:
      return state;
  }
};

// Action Creators
function saveRegistration(dispatch, toSaveData, config) {
  dispatch({
    type: SHOW_LOADER
  });
  var resp = (0, _accountDataApi.registerUser)(toSaveData, config);
  resp.then(function (response) {
    dispatch({
      type: SAVE_NEW_ACCOUNT,
      data: {
        innerData: response
      }
    });
    dispatch({
      type: HIDE_LOADER
    });
  }).catch(function (response) {
    dispatch({
      type: API_ERROR,
      data: {
        innerData: response
      }
    });
    dispatch({
      type: HIDE_LOADER
    });
  });
  return resp;
}
function resetSteps(dispatch, step) {
  dispatch({
    type: RESET_TO_FIRST_STEP,
    data: {
      step: stages[step]
    }
  });
}
function removeAPiError(dispatch, errorName) {
  dispatch({
    type: REMOVE_API_ERROR,
    errorName: errorName
  });
}
function addPartnerId(dispatch, toSaveData) {
  dispatch({
    type: SHOW_LOADER
  });
  var promise = (0, _accountDataApi.addBusinessPartner)(toSaveData);
  promise.then(function (response) {
    (0, _myDataApi.refreshToken)().then(function () {
      _CacheHandler.default.clearByToken('contractaccounts');
      dispatch({
        type: HIDE_LOADER
      });
      dispatch({
        type: ADD_NEW_PARTNER,
        data: {
          innerData: response
        },
        step: stages.SuccessStep
      });
    });
  }).catch(function (error) {
    var _error$response, _error$response$data;
    var errorCode = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errors[0].code;
    if (errorCode) {
      var errorMsgArr = errorCode.split('.');
      var errorMsgCustomerMW = errorMsgArr[errorMsgArr.length - 1];
      if (errorMsgCustomerMW === 'secondRegistrationMissingPersonalName' || errorMsgCustomerMW === 'secondRegistrationMissingCompanyName') {
        dispatch({
          type: SEC_DELIMITED,
          data: {
            innerData: error.response,
            isCompany: errorMsgCustomerMW === 'secondRegistrationMissingCompanyName',
            error: errorMsgCustomerMW
          }
        });
      } else {
        dispatch({
          type: API_ERROR,
          data: {
            innerData: error
          }
        });
      }
    }
    dispatch({
      type: HIDE_LOADER
    });
  });
  return promise;
}
function onPhoneNumberValidation(dispatch, number, formName) {
  if (number) {
    dispatch({
      type: VALIDATE_PHONENUMBER_PENDING,
      data: {
        formName: formName
      }
    });
    (0, _accountDataApi.validatePhoneNumber)(number).then(function (result) {
      dispatch({
        type: VALIDATE_PHONENUMBER,
        data: {
          formName: formName,
          result: result
        }
      });
    }).catch(function (error) {
      dispatch({
        type: VALIDATE_PHONENUMBER,
        data: {
          formName: formName,
          error: error.response
        }
      });
    });
  } else {
    dispatch({
      type: VALIDATE_PHONENUMBER_RESET,
      data: {
        formName: formName
      }
    });
  }
}
var _default = exports.default = registrationReducer;